export default __webpack_public_path__ + "static/intro_mobile_reversed-poster-439d14cc7e8b5dd3fc0bdfe82588a596.avif";